// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__34NjG","option":"styles_option__aDWeu","active":"styles_active__2-iau"};